const SectionIds = {
    MainSection: 'MainSection'
} as const;

export default SectionIds;
